module.exports = __webpack_public_path__ + "img/icon.aaf59c39.png";